import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroChevronRight, heroInformationCircle } from '@ng-icons/heroicons/outline';
import { ConversationFiltersStore } from '../../data/conversation-filters.store';
import { ConversationsStore } from '../../data/conversations.store';
import { UiIconButton, UiLabel } from '../../../../shared/ui';
import { DetailsPanelContentComponent } from '../details-panel-content/details-panel-content';

/**
 * Side-rail context panel: header (title + open/close toggle) wrapping the shared
 * {@link DetailsPanelContentComponent}.
 */
@Component({
  selector: 'app-conversation-details-panel',
  imports: [NgIcon, UiIconButton, UiLabel, DetailsPanelContentComponent],
  providers: [provideIcons({ heroChevronRight, heroInformationCircle })],
  templateUrl: './details-panel.html',
  styleUrls: ['./details-panel.css', '../conversation-atoms.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsPanelComponent {
  protected readonly store = inject(ConversationsStore);
  protected readonly filters = inject(ConversationFiltersStore);
  protected readonly conversation = computed(() => this.store.selectedConversation());
}
